<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="dfzl">
      <div class="zltb">
        <img src="../common/images/lawColumn/banner.png" alt="" />
      </div>
      <div class="zlList">
        <ul>
          <li
            class="lidome"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.id)"
          >
            <span class="title" :title="item.title">{{ item.title }}</span>
            <span class="time">{{ item.published }}</span>
          </li>
        </ul>
      </div>
      <div class="zlpage">
        <el-pagination
          v-if="showpag"
          id="FY"
          background
          layout="prev, pager, next"
          :total="totalNum"
          :current-page="currentPage"
          @current-change="pagefun"
          :page-size="10"
        >
        </el-pagination>
      </div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
export default {
  name: "lawColumn",
  components: { topNav, Bottoms },
  data() {
    return {
      list: [],
      // list: [
      //   {
      //     title: "5.15全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title:
      //       "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      //   {
      //     title: "全国投资者保护宣传日全国投资者保护宣传日全国投资者保护宣传日",
      //     time: "2021-05-15",
      //   },
      // ],
      showpag: false, //展示分页
      currentPage: 1, //初始页
      totalNum: "", //文章数量

      // pages: {
      //   current: 1,
      //   total: 100,
      //   size: 10,
      // },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var lawColumn = localStorage.getItem("lawColumn")
      ? localStorage.getItem("lawColumn")
      : "xxxx";
    if (lawColumn != "xxxx") {
      var json = JSON.parse(lawColumn);
      if (json.showHistory == 3) {
        this.currentPage = json.page;
      }
      json.showHistory = 1;
      var obj = JSON.stringify(json);
      localStorage.setItem("lawColumn", obj);
    }

    this.getlist();
  },
  methods: {
    getlist: function () {
      var p = {
        page: this.currentPage,
        limit: 10,
      };
      this.$api.illegal_list(p).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list;
          this.totalNum = res.data.total;
          this.showpag = true;
          this.list.map(function (item) {
            item.published = item.published.split(" ")[0];
          });
        } else {
          alert("获取失败");
        }
      });
    },
    pagefun: function (p) {
      this.currentPage = p;
      this.getlist();

      console.log(p);
    },
    toDetail: function (id) {
      var thisPage = this.currentPage;
      var lawColumn = {
        showHistory: 2,
        page: thisPage,
      };
      var json = JSON.stringify(lawColumn);
      localStorage.setItem("lawColumn", json);

      this.$router.push({
        name: "lawcDetail",
        query: {
          id: id,
        },
      });

      // this.$router.push({ path: "/lawcDetail" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dfzl {
  width: 100%;
  overflow: hidden;
}
.zltb {
  width: 100%;
  height: 400px;
}

.zlList,
.zlpage {
  width: 1226px;
  overflow: hidden;
  margin: 0 auto;
}
.zlpage {
  margin-top: 40px;
  margin-bottom: 60px;
}
.zlList ul {
  margin-top: 14px;
  width: 100%;
  overflow: hidden;
}
.lidome {
  width: 100%;
  height: 97px;
  border-bottom: 1px solid #d5d5d5;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  padding-top: 46px;
  box-sizing: border-box;
  cursor: pointer;
}
.lidome:hover .title {
  color: #e7413b;
}
.lidome:hover .time {
  color: #e7413b;
}
.lidome span {
  display: block;
}
.title {
  width: 821px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 37px;
  color: #333333;
  opacity: 1;
  text-align: left;
  /*  */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.time {
  width: 200px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 37px;
  color: #666666;
  opacity: 1;
  text-align: right;
}
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/lawColumn.vue